import { isDesktopMediaQueryValue } from "@/constants";

export const isDesktop = () => {
 return window.innerWidth >= isDesktopMediaQueryValue;
};
